import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/logo/Logo";
import Nav from "./Nav";
import MobileMenu from "./MobileMenu";

const HeaderBottomOne = () => {
  return (
    <>
      <div className="header-bottom">
        <div className="header-container">
          <div className="row d-flex align-items-center">
            <div className="col-xl-2 col-lg-2 col-md-2 logo-container">
              <Logo />
            </div>
            <div className="col-xl-8 col-lg-8 col-md-8 nav-container">
              <Nav />
            </div>
            <div className="col-xl-2 col-lg-2 col-md-2 header-btn-container ">
              {/* <div className="header-btn">
                <Link to="#" className="account-btn">
                  Account
                </Link>
              </div> */}
              <div className="header-btn">
                <Link to="/PDFViewer" className="ce-action-btn">
                  CE Action Plan
                </Link>
              </div>
            </div>
            <div className="col-12">
              <div className="mobile-menu">
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderBottomOne;
